import { _ui, type AdminUIConfig } from './_store';

export type { AdminUIConfig, FieldOverride } from './_store';

export function registerAdminUI(label: string, cfg: AdminUIConfig): void {
    _ui.set(label, cfg);
}

export function getAdminUI(label: string): AdminUIConfig {
    return _ui.get(label) ?? {};
}
